// Intentionally global
___export = require('./../../lib/src-server/azure-timer').run(require('./../../lib/src-server/example-timer').tick);
module.exports = ___export;


//////////////////
// WEBPACK FOOTER
// ./deployment/example-timer/build.source.js
// module id = 287
// module chunks = 16